// UF-04: how fed is a run? Pure summary of the deliveries linked to it.
// "Tipped out" = the delivery has no bins left to tip (bins_remaining 0).
export interface LinkedDelivery {
  delivery_id: string
  delivery_note_number: string | null
  client_ref_no: string | null
  bins_remaining: number | null
}

export interface RunFed {
  total: number
  tippedOut: number
  waiting: { delivery_id: string; label: string; bins: number }[]
}

/** null when no delivery is linked (berry runs, empty runs): no line. */
export function summariseRunFed(rows: LinkedDelivery[]): RunFed | null {
  if (rows.length === 0) return null
  const waiting = rows
    .filter(d => (d.bins_remaining ?? 0) > 0)
    .map(d => ({
      delivery_id: d.delivery_id,
      label: d.delivery_note_number || d.client_ref_no || 'delivery',
      bins: d.bins_remaining as number,
    }))
  return { total: rows.length, tippedOut: rows.length - waiting.length, waiting }
}
